import Style from './surveyAnswers.module.css';
import { SurveyAnswersProps } from './surveyAnswers';
import { isNullOrEmpty } from '../../helpers/string-helper';
import { DialogModal } from 'src/components/dialogModal/dialogModal.component';
import { SurveyAnswersColumnsContext, useSurveyAnswersLayout } from './surveyAnswersLayout';
import { useSurveyAnswersData } from './useSurveyAnswersData';
import { SurveyAnswersHeader, SurveyAnswersLegend, SurveyAnswersTable } from './surveyAnswersContent.component';

export const SurveyAnswers = (props: SurveyAnswersProps) => {
  const data = useSurveyAnswersData(props);

  const { swipeIndex, setSwipeIndex, setTableElement, visibleColumns, tableStyle } = useSurveyAnswersLayout(
    data.answersList?.length ?? 0,
    props.answerId,
    data.questionsList,
  );

  const legendSection =
    data.legend && !isNullOrEmpty(data.legend) ? <SurveyAnswersLegend legend={data.legend} /> : undefined;

  return (
    <DialogModal
      title={props.title}
      header={
        <SurveyAnswersHeader surveysData={data.surveysData} answersList={data.answersList} answerId={props.answerId} />
      }
      visible={props.isVisible}
      onHide={props.onClose}
      isClickOutside={true}
      bodyClassName={Style.body}
      footer={{ legendSection }}
      testId={`survey-form-result-${props.surveyType}`}
    >
      <SurveyAnswersColumnsContext.Provider value={visibleColumns}>
        <div ref={setTableElement} className={Style.table} style={tableStyle}>
          <SurveyAnswersTable
            answersList={data.answersList}
            answersStatisticsList={data.answersStatisticsList}
            questionsList={data.questionsList}
            isLoading={data.isLoading}
            answerId={props.answerId}
            swipeIndex={swipeIndex}
            onSwipe={setSwipeIndex}
          />
        </div>
      </SurveyAnswersColumnsContext.Provider>
    </DialogModal>
  );
};
